import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-indicateurs',
  imports: [],
  templateUrl: './indicateurs.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './indicateurs.css',
})
export class Indicateurs {}
